// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CheckBox input[type=checkbox] {
  height: 1.2rem;
  width: 1.2rem;
  margin-right: 0.4rem;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./../gui/src/components/StylesGuide/Buttons/CheckBox/CheckBox.scss"],"names":[],"mappings":"AACI;EACI,cAAA;EACA,aAAA;EACA,oBAAA;EAEA,sBAAA;AADR","sourcesContent":[".CheckBox {\n    input[type=\"checkbox\"] {\n        height: 1.2rem;\n        width: 1.2rem;\n        margin-right: 0.4rem;\n        // margin-top: 10px;\n        vertical-align: middle;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
